;(function() {
  'use strict'

  service.$inject = ["$q", "searchTermsResource"];
  angular.module('core.services').factory('searchTermsService', service)

  /* @ngInject */
  function service($q, searchTermsResource) {
    var whitespaceRegex = /\s+/g
    var listeners = []
    var fetching
    var terms

    // TODO - remove after endpoint is live and confirmed data is as below
    // DEBUG - mock searchTermsResource
    // var searchTermsResource = {
    //     get: function () {
    //         return {
    //             success: function (cb) {
    //                 cb(null, [
    //                     { query: 'jimmy grants birthday' },
    //                     { query: 'foo bars foo' },
    //                     { query: '#jimmy' }
    //                 ])
    //                 return this;
    //             },
    //             error: angular.noop
    //         };
    //     }
    // };

    get()

    return {
      search: search,
      create: create,
    }

    function get() {
      return $q(function(resolve, reject) {
        // add a listener
        listeners.push({ resolve: resolve, reject: reject })

        // wait if already fetching
        if (fetching) {
          return
        }

        // if already fetched, use those
        // TODO: invalidate and refresh after X minutes
        if (terms) {
          while (listeners.length) {
            var listener = listeners.pop()
            listener.resolve(terms)
          }
          return
        }

        // otherwise get from BE
        fetching = true
        searchTermsResource
          .get()
          .success(function(x, data) {
            terms = data

            // lowercase all terms
            _.each(terms, function(term) {
              term.query = term.query && term.query.toLowerCase()
            })

            // notify listeners
            while (listeners.length) {
              var listener = listeners.pop()
              listener.resolve(terms)
            }
            fetching = false
          })
          .error(function(response, status) {
            // TODO - remove when fully supported
            if (status === 404) {
              return degradeGracefully()
            }

            // notify listeners
            while (listeners.length) {
              var listener = listeners.pop()
              listener.reject()
            }
            fetching = false
          })

        function degradeGracefully() {
          terms = []

          // notify listeners
          while (listeners.length) {
            var listener = listeners.pop()
            listener.resolve(terms)
          }

          fetching = false
        }
      })
    }

    function search(query) {
      return $q(function(resolve, reject) {
        var matches = []

        // no query = no terms
        if (!query) {
          return reject()
        }

        // fetch from BE
        get().then(
          function(terms) {
            // lowercase our query
            query = query.toLowerCase()

            // split our query into words
            var words = query.split(whitespaceRegex)

            // remove duplicates
            words = _.uniq(words)

            var allWordsRegex = new RegExp('(' + words.join('|') + ')', 'g')

            // map into case-insensitive regex's for each word
            words = _.map(words, function(word) {
              return {
                text: word,
                regex: new RegExp(word, 'ig'),
              }
            })

            // loop each term
            _.each(terms, function(term) {
              if (!term.query) {
                return
              }

              // start with a fresh relevance/html
              term.html = term.query
              term.relevance = 0

              // add relevance for each word matched
              _.each(words, function(word) {
                if (term.query.match(word.regex)) {
                  term.relevance++
                }
              })

              // if any relevance
              if (term.relevance > 0) {
                // generate display html
                term.html = term.query.replace(allWordsRegex, '<b>$1</b>')

                // add to matches list
                matches.push(term)
              }
            })

            // resolve or reject

            if (matches.length) {
              resolve(matches)
            } else {
              reject()
            }
          },
          function() {
            reject()
          }
        )
      })
    }

    function validQuery(query) {
      // must be a string
      if (!_.isString(query)) {
        return false
      }

      // must have some characters
      if (query.length <= 3) {
        return false
      }

      // must be less than 5 words
      if (query.split(' ').length >= 5) {
        return false
      }

      return true
    }

    function create(query, type, identifier) {
      return $q(function(resolve, reject) {
        if (!validQuery(query)) {
          return reject()
        }
        // Note: type/identifier are used by BE for analytical knowledge, eg
        // if a duplicate query exists it will just increment the counter not create a new document
        var data = {
          query: query,
          type: type,
          identifier: identifier,
        }
        searchTermsResource
          .create(data)
          .success(function() {
            // if we haven't fetched terms yet, we are done!
            if (!terms) {
              return resolve()
            }

            // if have a local copy of this term, optimistically increment!
            var term = _.find(terms, { query: query })
            if (term) {
              term.count++
              return resolve()
            }

            // otherwise we dont have one, optimistically add it
            terms.push({
              query: query,
              count: 1,
            })

            resolve()
          })
          .error(reject)
      })
    }
  }
})()
